import { motion } from 'framer-motion';
import { Heading } from '@hungryroot/ramen';
import { ColorTextPrimaryInverted } from '@hungryroot/tokens';
import {
  ANIMATION_BASE_DURATION,
  ANIMATION_EASING,
  type ValuePropComponentTheme,
} from '../../defs/valueProp';
import { Logo } from './Logo';
import styles from './ValuePropHeader.module.css';

interface Props {
  heading: string;
  theme: ValuePropComponentTheme;
  headingClassName?: string;
}

export function ValuePropHeader({ heading, theme, headingClassName }: Props) {
  return (
    <header className={styles[`theme-${theme}`]}>
      <div className={styles['logo-container']}>
        <Logo fill={ColorTextPrimaryInverted} className={styles.logo} />
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ ...ANIMATION_EASING, duration: ANIMATION_BASE_DURATION }}
      >
        <Heading
          variant="H1Alt"
          className={`${styles.heading} ${headingClassName}`}
        >
          {heading}
        </Heading>
      </motion.div>
    </header>
  );
}
